import React from 'react'
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Trans } from "react-i18next";

const Congratulations = ({user,open,navigate}) => {
  return (
    <Modal
    isOpen={open}
    className="premiumBenifit vertically-center apd5 mt-3 mt-md-0"
  >
    <ModalHeader >
      <div className="amtN45 relPos">
        <img
          src={user.images}
          alt=""
          className="premiumBDP"
        />
        <div class="preIcon"></div>
      </div>
    </ModalHeader>
    <ModalBody>
      <div className="premiumBenifitPopup">
        <div className="mb-4">
          <div className="apk-24 pink-color text-center bold-font">
            <Trans i18nKey="A new way to date">A new way to date</Trans>!
          </div>
          <div className="apk-20 text-center bold-font">
            <Trans i18nKey="The most secure way of dating">
              The most secure way of dating
            </Trans>
            .
          </div>
        </div>
        <div className="premiumBenifitOverflow">
          <div className="form-group">
            <div className="apk-22 d-flex">
              {" "}
              <div class="tickIco mr-2"></div>{" "}
              <Trans i18nKey="Unlimited likes">Unlimited likes</Trans>
            </div>
            <div className="aml35">
              <Trans i18nKey="premiumText">
                Includes this striking feature that allows users to change
                their location and search for new matches or people who
                live in another area.
              </Trans>
            </div>
          </div>
          <div className="form-group">
            <div className="apk-22 d-flex">
              {" "}
              <div class="tickIco mr-2"></div>{" "}
              <Trans i18nKey="Meet someone interesting">
                Meet someone interesting
              </Trans>
            </div>
            <div className="aml35">
              <Trans i18nKey="premiumText">
                Includes this striking feature that allows users to change
                their location and search for new matches or people who
                live in another area.
              </Trans>
            </div>
          </div>
          <div className="form-group">
            <div className="apk-22 d-flex">
              {" "}
              <div class="tickIco mr-2"></div>{" "}
              <Trans i18nKey="Go inginito">Go inginito</Trans>
            </div>
            <div className="aml35">
              <Trans i18nKey="premiumText">
                Includes this striking feature that allows users to change
                their location and search for new matches or people who
                live in another area.
              </Trans>
            </div>
          </div>
          <div className="form-group">
            <div className="apk-22 d-flex">
              {" "}
              <div class="tickIco mr-2"></div>{" "}
              <Trans i18nKey="Hide your age">Hide your age</Trans>
            </div>
            <div className="aml35">
              <Trans i18nKey="premiumText">
                Includes this striking feature that allows users to change
                their location and search for new matches or people who
                live in another area.
              </Trans>
            </div>
          </div>
          <div className="form-group">
            <div className="apk-22 d-flex">
              {" "}
              <div class="tickIco mr-2"></div>
              <Trans i18nKey="No ads">No ads</Trans>
            </div>
            <div className="aml35">
              <Trans i18nKey="premiumText">
                Includes this striking feature that allows users to change
                their location and search for new matches or people who
                live in another area.
              </Trans>
            </div>
          </div>
        </div>
        <div class="apd10 text-center">
          <button
            class="border-0 pink-color white-bg text-center apk-24"
            onClick={navigate}
          >
            <Trans i18nKey="Continue">Continue</Trans>
          </button>
        </div>
      </div>
    </ModalBody>
  </Modal>
  )
}

export default Congratulations